const PERMISSION_KEY= "community:course_lesson";
const PAGE_URL = {
    COURSE_LESSON_PAGE: "/admin/community/course-lesson"
}

export {PERMISSION_KEY, PAGE_URL}

